module.exports = {
	"config": {
		"siteTitle": "Test Blog, Please Ignore",
		"siteDescr": "Slowly figuring out how these dang computers work.",
		"siteAuthor": "James A Keene",
		"siteTelegramUrl": "#",
		"siteTwitterUrl": "https://twitter.com/_jak",
		"siteGithubUrl": "https://github.com/jamak",
		"siteEmailUrl": "mailto:me@jamesakeene.com",
		"siteRssUrl": "#",
		"siteVkUrl": "#",
		"linkPrefix": "/"
	},
	"relativePath": "",
	"pages": [
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "_template.jsx",
				"ext": "jsx",
				"name": "_template",
				"extname": ".jsx",
				"basename": "_template.jsx",
				"dirname": "",
				"stem": "_template",
				"path": "_template.jsx",
				"absolute": "/Users/jkeene/dev/Me/blog/_template.jsx",
				"isAbsolute": false
			},
			"requirePath": "_template.jsx",
			"templatePath": "//",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "404.md",
				"ext": "md",
				"name": "404",
				"extname": ".md",
				"basename": "404.md",
				"dirname": "",
				"stem": "404",
				"path": "404.md",
				"absolute": "/Users/jkeene/dev/Me/blog/404.md",
				"isAbsolute": false
			},
			"requirePath": "404.md",
			"path": "/404.html",
			"data": {
				"path": "/404.html",
				"layout": "page"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "articles/2012-09-30-in-b-flat",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "articles/2012-09-30-in-b-flat",
				"stem": "index",
				"path": "articles/2012-09-30-in-b-flat/index.md",
				"absolute": "/Users/jkeene/dev/Me/blog/articles/2012-09-30-in-b-flat/index.md",
				"isAbsolute": false
			},
			"requirePath": "articles/2012-09-30-in-b-flat/index.md",
			"path": "/articles/2012-09-30-in-b-flat/",
			"data": {
				"title": "in B flat",
				"date": "2012-09-30T05:46:07.000Z",
				"layout": "post",
				"category": "music art cool",
				"description": "random thing I found"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "articles/2012-12-30-spatial-datastructures-in-go",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "articles/2012-12-30-spatial-datastructures-in-go",
				"stem": "index",
				"path": "articles/2012-12-30-spatial-datastructures-in-go/index.md",
				"absolute": "/Users/jkeene/dev/Me/blog/articles/2012-12-30-spatial-datastructures-in-go/index.md",
				"isAbsolute": false
			},
			"requirePath": "articles/2012-12-30-spatial-datastructures-in-go/index.md",
			"path": "/spatial-datastructures-1/",
			"data": {
				"title": "Spatial Datastructures in Go",
				"date": "2012-12-30T22:12:03.284Z",
				"layout": "post",
				"path": "/spatial-datastructures-1/",
				"category": "Go Quadtrees",
				"description": "A short introduction to writing spatial datastructures in Go."
			}
		},
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "index.jsx",
				"ext": "jsx",
				"name": "index",
				"extname": ".jsx",
				"basename": "index.jsx",
				"dirname": "",
				"stem": "index",
				"path": "index.jsx",
				"absolute": "/Users/jkeene/dev/Me/blog/index.jsx",
				"isAbsolute": false
			},
			"requirePath": "index.jsx",
			"path": "/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "pages/about",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "pages/about",
				"stem": "index",
				"path": "pages/about/index.md",
				"absolute": "/Users/jkeene/dev/Me/blog/pages/about/index.md",
				"isAbsolute": false
			},
			"requirePath": "pages/about/index.md",
			"path": "/about",
			"data": {
				"title": "About me",
				"layout": "page",
				"path": "/about"
			}
		},
		{
			"file": {
				"root": "",
				"dir": "pages/contact",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "pages/contact",
				"stem": "index",
				"path": "pages/contact/index.md",
				"absolute": "/Users/jkeene/dev/Me/blog/pages/contact/index.md",
				"isAbsolute": false
			},
			"requirePath": "pages/contact/index.md",
			"path": "/contact",
			"data": {
				"title": "Contact me",
				"layout": "page",
				"path": "/contact"
			}
		}
	]
}


/*****************
 ** WEBPACK FOOTER
 ** ../config.toml
 ** module id = 366
 ** module chunks = 0
 **/